import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { AxiosPromise } from 'axios'

// http://playable.dev.com:8067/?doc=monitor/api%2fmonitor%2fmid_whitelist.go

export function createWhitelist(data: { mids: string }): AxiosPromise {
  return request({
    url: `${v2Host}/monitor/mid-whitelist/create`,
    method: 'post',
    data
  })
}

export function deleteWhitelist(data: { mids: string }): AxiosPromise {
  return request({
    url: `${v2Host}/monitor/mid-whitelist/delete`,
    method: 'post',
    data
  })
}

export function fetchWhitelist(params: { mid: string, order: string, page?: number; page_size?: number; }): AxiosPromise {
  return request({
    url: `${v2Host}/monitor/mid-whitelist/list`,
    method: 'get',
    params
  })
}
